export const GET_TRANSACTION_CRITARIA_REQUEST="GET_TRANSACTION_CRITARIA_REQUEST"
export const GET_TRANSACTION_CRITARIA_SUCCESS="GET_TRANSACTION_CRITARIA_SUCCESS"
export const GET_TRANSACTION_CRITARIA_FAILURE="GET_TRANSACTION_CRITARIA_FAILURE"